
export default {
  props: {
    stream: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      experts: [],
      companys: [],
      users: [],
    }
  },
  async fetch() {
    await this.fetchExperts()
  },
  created() {
    if (process?.client) {
      this.$eventBus.$on('Product-subscribe', () => this.fetchExperts())
      this.$eventBus.$on('Product-unSubscribe', () => this.fetchExperts())
    }
  },
  beforeDestroy() {
    this.$eventBus.$off('Product-subscribe')
    this.$eventBus.$off('Product-unSubscribe')
  },
  methods: {
    async fetchExperts() {
      const { all, companys, users } = await this.$axios.$get(
        `/users/skill/${this.stream.stream.id}`
      )
      this.experts = all
      this.companys = companys
      this.users = users
    },
  },
}
